<template>
  <div class="client opportunity managers-editor">
    <v-btn icon @click="editing = !editing"> <v-icon>mdi-pencil</v-icon> </v-btn>
    <v-dialog v-model="editing" max-width="900px" width="66vw">
      <v-card>
        <v-card-title class="title">Edit Opportunity Managers</v-card-title>

        <v-divider />

        <v-card-text>
          <v-form v-model="valid" @submit.prevent="submit" ref="form">
            <v-autocomplete multiple chips dense hide-selected
              label="Assigned Managers"
              :items="options"
              v-model="assigned"
              item-text="name"
              item-value="id"
              return-object
              hint="Allocate opportunity managers"
              :color="themes.client.light.input"
            >
              <template
                v-if="item === Object(item)"
                slot="selection"
                slot-scope="{ item, parent, selected }"
              >
                <v-chip
                  :selected="selected"
                  :class="themes.client.light.chip"
                  :key="`manager-selection-${item.id}`"
                >
                  <v-avatar>
                    <img v-img-orientation-changer :src="item.avatar"/>
                  </v-avatar>
                  {{ item.name }}
                  <v-icon right small @click="parent.selectItem(item)">mdi-close</v-icon>
                </v-chip>
              </template>

              <template slot="item" slot-scope="{ index, item, parent }">
                <v-chip :class="themes.client.light.chip" :key="`manager-item-${item.id}`">
                  <v-avatar>
                    <img v-img-orientation-changer :src="item.avatar"/>
                  </v-avatar>
                  {{ item.name }}
                </v-chip>
              </template>
            </v-autocomplete>
          </v-form>
        </v-card-text>

        <v-card-actions
          ><v-spacer />
          <v-btn flat @click="editing = false" :color="themes.client.light.cancel"> Cancel </v-btn>
          <v-btn @click="submit" :color="themes.client.light.primaryActionButton"> Save </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
// Vue Component
export default {
  props: {
    opportunity: Object,
    edit: Boolean,
  },

  created() {
    this.$store.dispatch('client/users/fetchAll')
  },

  data() {
    return {
      assigned: JSON.parse(JSON.stringify(this.opportunity.managers)),
      editing: false,
      valid: true,
    }
  },

  computed: {
    users() {
      return this.$store.getters['client/users/all']
    },
    options() {
      return this.users.map(u => ({
        id: u.id,
        name: `${u.firstName} ${u.lastName}`,
        avatar: u.avatar ? u.avatar : '/img/missing/avatars/original.png',
      }))
    },
  },

  watch: {
    editing() {
      this.assigned = JSON.parse(JSON.stringify(this.opportunity.managers))
    },
  },

  methods: {
    submit() {
      this.editing = false
      this.$store
        .dispatch(
          'client/opportunities/update',
          Object.assign({}, JSON.parse(JSON.stringify(this.opportunity)), {
            managers: this.assigned,
          })
        )
        .then(
          data => {
            if (data && data.errors) {
              return this.$store.dispatch('snackbarError', 'Update failed.')
            }
            this.$store.dispatch('snackbarSuccess', 'Successfully updated.')
            this.$store.dispatch('client/opportunities/fetch', this.$route.params.id)
            Object.assign({}, this.opportunity, { managers: this.assigned })
          },
          () => {
            this.$store.dispatch('snackbarError', 'Update failed.')
          }
        )
    },
  },
}
</script>
